import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HexToRgb } from '../utilities';

const MenuTitleWrapper = styled.div`
  background-color: ${props => props.theme.carvana.white.primary};
  box-shadow: 1px 2px 3px 1px rgba(${props => HexToRgb(props.theme.carvana.blue.dark)}, 0.1);
  color: ${props => props.theme.carvana.gray.dark};
  display: flex;
  min-height: 43px;
  padding: 0px 9px;
  text-align: center;
`;

const MenuSpace = styled.div`
  flex: 1;
`;

const MenuTitle = styled.span`
  align-self: center;
  flex: ${props => (props.wide ? 2 : 1)};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;

const CloseWrapper = styled.div`
  align-items: center;
  color: ${props => props.theme.carvana.blue.primary};
  fill: ${props => props.theme.carvana.blue.primary};
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
const SvgWrapper = styled.div`
  display: block;
  width: 14px;
  height: 14px;
  margin: -7px 4px 0 0;
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

const DrawerTitle = ({ className, close, title, wideTitle = false }) => (
  <MenuTitleWrapper className={className}>
    <MenuSpace />
    <MenuTitle wide={wideTitle}>{title}</MenuTitle>
    <CloseWrapper onClick={close}>
      <SvgWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
          <g id="close-x-13x13-dark">
            <path d="M7.58,6.5l5.2-5.19a.79.79,0,0,0,0-1.09.79.79,0,0,0-1.09,0L6.5,5.42,1.31.22A.79.79,0,0,0,.22.22a.79.79,0,0,0,0,1.09L5.42,6.5.22,11.69a.79.79,0,0,0,0,1.09A.77.77,0,0,0,.77,13a.76.76,0,0,0,.54-.22L6.5,7.58l5.19,5.2a.79.79,0,0,0,1.09,0,.79.79,0,0,0,0-1.09Z" />
          </g>
        </svg>
      </SvgWrapper>
    </CloseWrapper>
  </MenuTitleWrapper>
);

DrawerTitle.defaultProps = {
  className: '',
};

DrawerTitle.propTypes = {
  className: PropTypes.string,
  close: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  wideTitle: PropTypes.bool,
};

export default DrawerTitle;
